import { ConnectPaymentDetails } from "@stripe/react-connect-js";
import { createFileRoute } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";

import { PageWrapper } from "~/components/page-wrapper";
import { ConnectProvider } from "~/components/stripe/connect-provider";
import { Button } from "~/components/ui/button";
import { Spinner } from "~/components/ui/spinner";
import { useActiveOrganization } from "~/integrations/vortex-auth/hooks";

export const Route = createFileRoute("/_authenticated/payments/$paymentId")({
  component: PaymentDetailsPage,
  pendingComponent: () => (
    <PageWrapper
      description="View detailed information about this payment"
      title="Payment Details"
    >
      <div className="flex items-center justify-center p-12">
        <Spinner className="size-8" />
      </div>
    </PageWrapper>
  ),
});

function PaymentDetailsPage() {
  const { paymentId } = Route.useParams();
  const { organization } = useActiveOrganization();
  const navigate = Route.useNavigate();

  if (!organization) {
    return null;
  }

  return (
    <PageWrapper
      description="View detailed payment information, issue refunds, and manage disputes"
      title="Payment Details"
    >
      <div className="flex flex-col gap-4">
        <Button
          className="self-start"
          onClick={() => navigate({ to: "/payments" })}
          size="sm"
          type="button"
          variant="ghost"
        >
          <ArrowLeft className="mr-2 size-4" />
          Back to Payments
        </Button>

        <div className="bg-background rounded-lg border p-6">
          <ConnectProvider organizationId={organization.id}>
            <ConnectPaymentDetails
              onClose={() => navigate({ to: "/payments" })}
              payment={paymentId}
            />
          </ConnectProvider>
        </div>
      </div>
    </PageWrapper>
  );
}
